import { render, staticRenderFns } from "./t-clipboard.vue?vue&type=template&id=e1baacc0&"
import script from "./t-clipboard.vue?vue&type=script&lang=js&"
export * from "./t-clipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports